export const COLOR = '#6369F1';
export const LIGHT_COLOR = '#EEF2FF';
export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/qixer-on-demand-service-marketplace`;
export const DEMO_URL = 'https://qixer.bytesed.com/';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.bytesed.qixer';
export const CODECANYON_URL = 'https://codecanyon.net/item/qixer-multivendor-on-demand-service-marketplace-and-service-finder/36475708';
export const REGULAR_PRICE = 59;
export const COMBO_PRICE = 99;
export const EXTENDED_PRICE = 199;

export const REVIEWS = [
  {
    name: 'rhinocreativeagencyweb',
    rating: 5,
    category: 'Feature Availability',
    body: 'At first we tried other scripts — too buggy. After two months we found Qixer. It\'s high quality, infinitely flexible, and full of every feature you could want for a service provider marketplace. Customer support is always helpful through the dedicated ticket system.',
  },
  {
    name: 'Brandicon',
    rating: 5,
    category: 'Code Quality',
    body: 'This has everything you can dream of — design, code, documentation, and support. Built like WordPress with pages and widgets so you can customize quickly. Updating is automated with excellent instructions. Design is great, UX is great too.',
  },
  {
    name: 'DUNAMIS-888',
    rating: 5,
    category: 'Customer Support',
    body: 'The response time from the support ticket was about 10 minutes. Coming from a strong IT background, I can without a shadow of a doubt recommend this script for true internet entrepreneurs.',
  },
  {
    name: 'MyKodezone',
    rating: 5,
    category: 'Code Quality',
    body: 'The Qixer Application\'s code quality and support are excellent. The team is highly responsive and resolves issues quickly. I highly recommend them for anyone looking for a reliable service marketplace solution.',
  },
  {
    name: 'crystalcash',
    rating: 5,
    category: 'Customer Support',
    body: 'Exceptional experience. The representative responded promptly and was incredibly professional throughout the entire process. Couldn\'t ask for better support.',
  },
  {
    name: 'brazilprime5',
    rating: 5,
    category: 'Customer Support',
    body: 'They are very helpful especially on support and problem handling. Every issue I raised was addressed quickly and professionally.',
  },
  {
    name: 'SashaAngel',
    rating: 5,
    category: 'Customer Support',
    body: 'Great support! Very professional! Thanks for help! The team went above and beyond to resolve my setup questions.',
  },
  {
    name: 'ddakser',
    rating: 5,
    category: 'Overall',
    body: 'Best in CodeCanyon, in every aspect. The script, the documentation, the support — all top tier. Nothing else comes close in this category.',
  },
  {
    name: 'Alexcastt',
    rating: 5,
    category: 'Customer Support',
    body: 'Very good customer support, they always help you and give solutions. No matter what problem I encountered, the team had an answer ready.',
  },
  {
    name: 'saziii',
    rating: 5,
    category: 'Customer Support',
    body: 'Speedy resolution of problems, thumbs up! Issues were handled faster than I expected. Great team behind this product.',
  },
  {
    name: 'noel1999',
    rating: 5,
    category: 'Customer Support',
    body: 'Very good support. Quick responses and helpful guidance throughout the installation and customization process.',
  },
  {
    name: 'lricardobadao',
    rating: 4,
    category: 'Feature Availability',
    body: 'All the questions have been answered and the features cover everything I needed for my marketplace. A solid script overall — very happy with the purchase.',
  },
];
